import { create } from 'zustand';
import { StoreConfigStoreInterface } from './types';

const StoreConfigStore = create<StoreConfigStoreInterface>()((set) => {
  return {
    storeConfig: null,

    setStoreConfig: (config) => {
      set(() => ({
        storeConfig: config,
      }));
    },
  };
});

export default StoreConfigStore;
